import { makeCSRFRequest } from "../../utils/csrf";
import { BASE_URL } from "../../App";

export const deletePost = async (postId, userId, member) => {
  const token = localStorage.getItem("minebikers_token");
  if (!token || (!userId && !member)) {
    return false;
  }
  try {
    const response = await makeCSRFRequest(
      `${BASE_URL}/vieraskirja/post/${postId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ userId }),
      }
    );
    if (!response.ok) {
      throw new Error("Failed to delete message");
    }
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
